import { Service, ServiceResponse } from './service';

export class CommunityService extends Service {
  constructor() {
    super();
  }

  public async init(): Promise<ServiceResponse> {
    return {success: true};
  }

  public async sync(): Promise<ServiceResponse> {
    return {success: true};
  }
}